export default __webpack_public_path__ + "static/media/success-tick.154a0a6a.svg";